// extracted by mini-css-extract-plugin
export default {"table":"contactUs_table__2oPGO"};